export default "__VITE_PUBLIC_ASSET__81300de6__"